import React from 'react';
import { Button, Box, Typography, TextField } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers';
import { Snackbar as SnackbarComponent, LoadingButton } from 'components';
import { useUser, useSnackbar, useLoading } from 'hooks';

import history from 'services/history';
import api from 'services/api';
import useStyles from '../../styles';
import schema from './schema';

const Form = () => {
  const classes = useStyles();

  const { signIn } = useUser();
  const { openSnackbar } = useSnackbar();
  const { setLoading } = useLoading();

  const { register, handleSubmit, errors, control } = useForm({
    validationSchema: schema,
    defaultValues: {
      email: '',
      password: '',
    },
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await api.post('/sessions', data);

      signIn(response.data.user, response.data.token);

      const profileId = response.data.user.profile_id;

      if (profileId === 1) {
        history.replace('/admin');
      } else if (profileId === 2) {
        history.replace('/app');
      } else if (profileId === 4) {
        history.replace('/garcon/requestsTablesAdd');
      } else {
        history.replace('/cart');
      }
    } catch (error) {
      openSnackbar(error.response.data.message, 'error');
    }
    setLoading(false);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="email"
          as={
            <TextField
              variant="outlined"
              margin="normal"
              label="Email"
              inputRef={register}
              fullWidth
              error={!!errors.email}
              helperText={errors && errors.email && errors.email.message}
            />
          }
          control={control}
        />
        <Controller
          name="password"
          as={
            <TextField
              variant="outlined"
              margin="normal"
              label="Senha"
              type="password"
              inputRef={register}
              fullWidth
              error={!!errors.password}
              helperText={errors && errors.password && errors.password.message}
            />
          }
          control={control}
        />

        <Box align="right" my={2}>
          <Link to={'/reset-password'} className={classes.removeStyleLink}>
            <Typography>Esqueceu a senha?</Typography>
          </Link>
        </Box>
        <Box my={1}>
          <LoadingButton
            type="submit"
            color="primary"
            variant="contained"
            fullWidth
            size={30}
          >
            Entrar
          </LoadingButton>
        </Box>
        <Box my={2} align="center">
          <Typography variant="subtitle1">ou</Typography>
        </Box>
        <Box my={1}>
          <Button
            type="submit"
            color="secondary"
            fullWidth
            variant="contained"
            onClick={() => history.push('/register')}
          >
            Cadastre-se
          </Button>
        </Box>
      </form>

      <SnackbarComponent />
    </>
  );
};

export default Form;
